import React from 'react'

export default function News() {
    return (
        <div>
            this is the news page
        </div>
    )
}
